import React from "react";

const PlansAndPricing = () => {
  return <div>PlansAndPricing</div>;
};

export default PlansAndPricing;
